var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.item.hidden
    ? _c(
        "div",
        { staticClass: "menu-wrapper" },
        [
          _vm.hasOneShowingChild(_vm.item.children, _vm.item) &&
          (!_vm.onlyOneChild.children || _vm.onlyOneChild.noShowingChildren) &&
          !_vm.item.alwaysShow
            ? [
                _vm.onlyOneChild.meta
                  ? _c(
                      "app-link",
                      {
                        ref: _vm.resolvePath(_vm.onlyOneChild.path),
                        attrs: { to: _vm.resolvePath(_vm.onlyOneChild.path) },
                        nativeOn: {
                          mouseleave: function ($event) {
                            _vm.itemMouseleve(
                              _vm.resolvePath(_vm.onlyOneChild.path)
                            )
                          },
                          mouseover: function ($event) {
                            _vm.itemMouse(
                              _vm.resolvePath(_vm.onlyOneChild.path)
                            )
                          },
                        },
                      },
                      [
                        _c(
                          "el-menu-item",
                          {
                            class: { "submenu-title-noDropdown": !_vm.isNest },
                            style:
                              _vm.currPath ===
                              _vm.resolvePath(_vm.onlyOneChild.path)
                                ? "background:linear-gradient(270deg, rgba(" +
                                  _vm.colorConversionRgb(_vm.leftNavSetBg) +
                                  ",0.61) 20%, rgba(" +
                                  _vm.colorConversionRgb(_vm.leftNavBg) +
                                  ",1) 100%) !important"
                                : "''",
                            attrs: {
                              index: _vm.resolvePath(_vm.onlyOneChild.path),
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "bar",
                              style:
                                _vm.currPath ===
                                _vm.resolvePath(_vm.onlyOneChild.path)
                                  ? "background:rgb(" +
                                    _vm.colorConversionRgb(_vm.leftNavSetBg) +
                                    ")"
                                  : "",
                            }),
                            _vm._v(" "),
                            _c("item", {
                              style:
                                "color:rgba(" +
                                _vm.colorConversionRgb(_vm.leftNavBg) +
                                ",1)",
                              attrs: {
                                icon:
                                  _vm.onlyOneChild.meta.icon ||
                                  (_vm.item.meta && _vm.item.meta.icon),
                                title: _vm.onlyOneChild.alwaysShow
                                  ? _vm.item.meta.title
                                  : _vm.onlyOneChild.meta.title,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            : _c(
                "el-submenu",
                {
                  ref: "subMenu",
                  attrs: {
                    index: _vm.resolvePath(_vm.item.path),
                    "popper-append-to-body": "",
                  },
                },
                [
                  _c(
                    "template",
                    { slot: "title" },
                    [
                      _vm.item.meta
                        ? _c("item", {
                            attrs: {
                              icon: _vm.item.meta && _vm.item.meta.icon,
                              title: _vm.item.meta.title,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.item.children, function (child) {
                    return _c("sidebar-item", {
                      key: child.path,
                      staticClass: "nest-menu",
                      style:
                        "background:rgba(" +
                        _vm.colorConversionRgb(_vm.leftNavBg) +
                        ",1)",
                      attrs: {
                        "is-nest": true,
                        item: child,
                        "base-path": _vm.resolvePath(child.path),
                      },
                    })
                  }),
                ],
                2
              ),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }